(function () {
  function initMollyHomeCards(root) {
    const cards = (root || document).querySelectorAll('[data-molly-home-card]');
    if (!cards.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('home__prod--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    cards.forEach((card) => observer.observe(card));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMollyHomeCards());
  } else {
    initMollyHomeCards();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initMollyHomeCards(event.target);
  });
})();
